import React from 'react';
import Work from '../Work';
import './index.scss';
import { iObra } from '../../Services/ObraServices';

interface iProps {
    collection: iObra[];
    handleClickWork?: any;
}

export default function Masonry({ collection,handleClickWork }: iProps) {

    return (
    <div className="c_grid">
        {collection &&
            collection.map((item, index) =>{
                return (<div key={index} className="c_grid__items">
                    <Work model={item} handleClickInfo={()=>{ }}></Work>
                    </div>)
            })
        }
    </div>
    )
}
